<modal #modal
        modalClass="modal-lg modal-md"
        [hideCloseButton]="false"
        [closeOnEscape]="false"
        [closeOnOutsideClick]="false"
        (onClose)="handleClose()">
 
    <modal-header class="w-100 text-center">
        <h4 class="h4-responsive modal-title text-center">PDF Report Configuration</h4>
    </modal-header>
 
    <modal-content class="container-fluid d-block">
        <div class="row">
            <div class="col text-center" *ngIf="!hideNotesOption">
                <input id='printSettingsDialogIncludeTherapistNotes' (click)="updateTherapistNoteSettings($event)" type="checkbox" class="form-control" />
                <label for='printSettingsDialogIncludeTherapistNotes'>Include Therapist Notes?</label>
            </div>
        </div>
        <div class="row">
            <div class="col text-center">
                <input *ngIf="!printing" type="button" class="btn btn-primary" value="Generate Report" (click)="handlePrint()" />
                <input *ngIf="printing" type="button" class="btn btn-secondary" disabled value="Generating PDF..." />
                <a *ngIf="printingComplete" class="btn btn-secondary" [href]="downloadFileUrl">Download PDF</a>
            </div>
        </div>
        <div class="row">
            <h6>Important Notice</h6>
            <p>Note the pdf printing can take a few seconds up to a few minutes depending on how large the report is and how many reports are currently being printed.</p>
        </div>
    </modal-content>
 
    <modal-footer></modal-footer>
        
</modal>


// WEBPACK FOOTER //
// ./src/app/reports/print-dialog/print-dialog.component.html